import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClickhouse = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 101,
	height: 101,
	viewBox: "0 0 101 101",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_3638_31469",
		style: { maskType: "luminance" },
		"mask-units": "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 101,
		height: 101,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M100.5 0.5H0.5V100.5H100.5V0.5Z",
			fill: "white"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_3638_31469)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M16.7011 8.3125H9.2986C8.75399 8.3125 8.3125 8.75399 8.3125 9.2986V91.6985C8.3125 92.2431 8.75399 92.6846 9.2986 92.6846H16.7011C17.2457 92.6846 17.6872 92.2431 17.6872 91.6985V9.2986C17.6872 8.75399 17.2457 8.3125 16.7011 8.3125Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.4511 8.3125H28.0486C27.504 8.3125 27.0625 8.75399 27.0625 9.2986V91.6985C27.0625 92.2431 27.504 92.6846 28.0486 92.6846H35.4511C35.9957 92.6846 36.4372 92.2431 36.4372 91.6985V9.2986C36.4372 8.75399 35.9957 8.3125 35.4511 8.3125Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M54.2011 8.3125H46.7986C46.254 8.3125 45.8125 8.75399 45.8125 9.2986V91.6985C45.8125 92.2431 46.254 92.6846 46.7986 92.6846H54.2011C54.7457 92.6846 55.1872 92.2431 55.1872 91.6985V9.2986C55.1872 8.75399 54.7457 8.3125 54.2011 8.3125Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M72.9472 8.3125H65.5447C65.0001 8.3125 64.5586 8.75399 64.5586 9.2986V91.6985C64.5586 92.2431 65.0001 92.6846 65.5447 92.6846H72.9472C73.4918 92.6846 73.9333 92.2431 73.9333 91.6985V9.2986C73.9333 8.75399 73.4918 8.3125 72.9472 8.3125Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M91.703 41.1259H84.3006C83.7559 41.1259 83.3145 41.5673 83.3145 42.112V58.8891C83.3145 59.4337 83.7559 59.8752 84.3006 59.8752H91.703C92.2476 59.8752 92.6891 59.4337 92.6891 58.8891V42.112C92.6891 41.5673 92.2476 41.1259 91.703 41.1259Z",
				fill: "black"
			})
		]
	})]
});
export default SvgClickhouse;
